module.exports = __webpack_public_path__ + "img/rec-ur3.a1f5c03e.jpg";